export default function() {

  let widgetName;
  let widgetOpts;
  
  if (window.siteTheme === 'Amphitheater') {
    widgetName = 'cardWidgetAmpBannerAd';
    widgetOpts = cardWidgetAmpBannerAdOpts;
  }
  if (window.siteTheme === 'Oncenter') {
    widgetName = 'cardWidgetOncBannerAd';
    widgetOpts = cardWidgetOncBannerAdOpts;
  }  

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function(data, owl, hasData) {
      // oncenter & amp subpages - show before footer
      if (!$('body').hasClass('homepage') && !$('body').hasClass('amp-homepage')) {
        $('<div class="subpage-pre-footer"></div>').insertBefore('.footer');
        $(`#${widgetName}`).appendTo('.subpage-pre-footer');
        if (window.siteTheme === 'Amphitheater') {
          // remove oncenter banner
          $(`#cardWidgetOncBannerAd`).remove();
        }
        if (window.siteTheme === 'Oncenter') {
          // remove amphitheater banner
          $(`#cardWidgetAmpBannerAd`).remove();
        }          
      }

      if ($('body').hasClass('homepage')) {
        $(`#${widgetName}`).insertAfter('#cardWidgetOncSlidingCards');
      }

      if ($('body').hasClass('amp-homepage')) {
        $(`#${widgetName}`).insertAfter('#cardWidgetAmpCircles');
      }
    
      $(`#${widgetName}`).show();
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    link: ['all'], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 20,
    moreButton: {
      visible: false,
      text: 'Buy Tickets'
    },
    scriptPath:  widgetOpts.scriptPath,
    showDescription: false,
    slideshow: true, // for documentation on Owl Slider: https://owlcarousel2.github.io/OwlCarousel2/docs/started-welcome.html
    slideshowOptions: {
      items: 1,
      loop: true,
      autoplay: true,
      autoplayTimeout: 5000,
      margin: 0,
      navText: ['Prev','Next'],
      nav: false,
      dots: false,
      onInitialize: function(element){
        $(`#${widgetName}`).children().sort(function(){
            return Math.round(Math.random()) - 0.5;
        }).each(function(){
            $(this).appendTo($(`#${widgetName}`));
        });
      }
    },
    textOverImage: false
  });

}